import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from "@angular/core";
import { appConstants } from "../../../core/config/constant";
import { SupplierV2Service } from "../service/supplier.v2.service";
import { RfqService } from './../../../core/services/rfq/rfq.service';
import { IPartLibraryModel } from "./../../../core/models/partModel";
import * as moment from 'moment';
import { DownloadAllFilesViewModel } from "./../../../core/models/rfqModel";
import { ProfileService } from "./../../../core/services/profile/profile.service";
import { Router } from "@angular/router";
import { AppUtil } from "./../../../../app/app.util";

interface SelectedRFQ {
  rfqId: number;
  buyerContactId?: number;
  finalQuoteStatus?:string;
  rfqName?:string;
}
@Component({
  selector: "supplier-parts-specification",
  templateUrl: "./supplier-parts-specification.component.html",
  styleUrls: ["./supplier-parts-specification.component.scss"],
})
export class SupplierSpecificationComponent implements OnInit, OnDestroy {
  @Output() drawer_OnClose = new EventEmitter < any > ();
  @Input() selectedRFQ: any = {};
  @Output() parentEmitter = new EventEmitter<{ showSidePanel: boolean }>();
  
  temp: string[];
  Downloadallfiles: DownloadAllFilesViewModel;
  iReviewPartsViewModelColl: IPartLibraryModel[];
  isLoader: boolean;
  selectedPartId: number;
  isFileDownloaded: number;
  isFileDownloaded1: number;
  isFileDownloaded2: number;

  partName: string;
  rfqid: string;
  isNewPart: string;
  quantityUnit: string;
  manufacturingProcess: string;
  manufacturingTechnique: string;
  material: string;
  postProductionProcess: string;
  dimensions: string;

  constructor(
    private _rfqService: RfqService, 
    private router: Router,
    private profileService: ProfileService
  ) {
    this.isLoader = true;
  }

  ngOnInit() {
    this.getPartsList();
  }

  ngOnDestroy() {
    this.closePartDrawer();
  }

  closePartDrawer() {
    this.drawer_OnClose.emit({drawerClose:true});
  }
  clickOutside(event: MouseEvent) {
    // const target = event.target as HTMLElement;
    // if (target && target.classList.contains('view-insight-button')) {
    //   return; // Ignore click if it's from the button
    // }
    this.closePartDrawer();
  }

  get loggedId() {
    return parseInt(AppStorageUtil.getItem('LoggedId'));
  }

  editQuote(rfqId) {
    AppStorageUtil.setItem('quotesTab', "true");
    const encryptedRfqID = this.profileService.encrypt(rfqId);
    this.router.navigate(["/supplier/supplierRfqDetails"], {
      queryParams: { rfqId: encryptedRfqID },
    });
  }

  getPartsList() {
    this._rfqService.getReviewRfqParts(this.selectedRFQ.rfqId, this.loggedId, false).subscribe(
      result => {
        if(result){
          this.iReviewPartsViewModelColl = result.filter(part => part.partId === this.selectedRFQ.partId);
          this.iReviewPartsViewModelColl.forEach(part => {
            part.deliveryDate = moment.utc(part.deliveryDate).toDate();
            part.partDescription = part.partDescription + '<br>' + part.customPartDescription;
            part.dimensions = AppUtil.formatDimensions(part.depth, part.width, part.height, part.partSizeUnitId);
          });
          this.isLoader = false;
        }
      },
      error => {
        this._rfqService.handleError(error);
      },
      () => { }
    );
  }
  downloadS3File(fileName: string, isDownload: boolean) {
    ++this.isFileDownloaded;
    this._rfqService.getS3FileDownload(fileName).subscribe(response => {
      --this.isFileDownloaded;
      if (response.result && response.result.result && response.result.result === true) {
        const resData = response.result;
        const filelink = resData.fileName;
        if (filelink) {
          if (/(iP)/g.test(navigator.userAgent)) {
            window.open(filelink, '_blank');
          }
          // If in Chrome or Safari - download via virtual link click
          const link = document.createElement('a');
          link.href = filelink;
          link.setAttribute('target', '_blank');

          if (link.download !== undefined && isDownload) {
            // Set HTML5 download attribute. This will prevent file from opening if supported.
            fileName = filelink.substring(filelink.lastIndexOf('/') + 1, filelink.length);
            link.download = fileName;
          }
          // Dispatching click event.
          if (document.createEvent) {
            const e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
          }
        }
      }
    });
  }

  downloadAllFiles(fileCompArray: string[], partfile, partId, rfqId, isFileDownloaded) {
    if (isFileDownloaded === 'isFileDownloaded') {
      ++this.isFileDownloaded;
    }
    if (isFileDownloaded === 'isFileDownloaded1') {
      ++this.isFileDownloaded1;
    }
    if (isFileDownloaded === 'isFileDownloaded2') {
      ++this.isFileDownloaded2;
    }
    this.Downloadallfiles = {
      filename: [],
      rfQ_Id: 0,
      part_id: 0

    };
    this.temp = [];
    let data = JSON.stringify(fileCompArray);
    this.temp = JSON.parse(data);
    if (partfile !== '') {
      this.temp.push(partfile);
    }
    this.Downloadallfiles.filename = this.temp;
    this.Downloadallfiles.part_id = partId;
    this.Downloadallfiles.rfQ_Id = rfqId;

    this._rfqService.getDownloadAllFileURL(this.Downloadallfiles).subscribe(response => {
      if (response.result === true) {
        const resData = response.data;
        const filelink = resData.privateFileFileName;
        if (filelink) {
          if (/(iP)/g.test(navigator.userAgent)) {
            window.open(filelink, '_blank');
          }
          // If in Chrome or Safari - download via virtual link click
          const link = document.createElement('a');
          link.href = filelink;

          link.setAttribute('target', '_blank');
          // Dispatching click event.
          if (document.createEvent) {
            const e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
          }
        }

        if (isFileDownloaded === 'isFileDownloaded') {
          --this.isFileDownloaded;
        }

        if (isFileDownloaded === 'isFileDownloaded1') {
          --this.isFileDownloaded1;
        }

        if (isFileDownloaded === 'isFileDownloaded2') {
          --this.isFileDownloaded2;
        }

      } else {
        if (isFileDownloaded === 'isFileDownloaded') {
          --this.isFileDownloaded;
        }

        if (isFileDownloaded === 'isFileDownloaded1') {
          --this.isFileDownloaded1;
        }

        if (isFileDownloaded === 'isFileDownloaded2') {
          --this.isFileDownloaded2;
        }

      }
    }, error => {
      if (isFileDownloaded === 'isFileDownloaded') {
        --this.isFileDownloaded;
      }

      if (isFileDownloaded === 'isFileDownloaded1') {
        --this.isFileDownloaded1;
      }

      if (isFileDownloaded === 'isFileDownloaded2') {
        --this.isFileDownloaded2;
      }

    })
  }
 
}
